var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2368 9.83333V8.5V7.16667H14.3333C14.7015 7.16667 15 6.86819 15 6.5C15 6.13181 14.7015 5.83333 14.3333 5.83333H12.2368V5.3C12.2368 4.85817 11.8787 4.5 11.4368 4.5H8.39868C8.3675 4.5 8.33673 4.50178 8.30647 4.50526C8.23547 4.50177 8.164 4.5 8.0921 4.5C6.0381 4.5 4.33306 5.94193 4.00454 7.83414C3.99359 7.83361 3.98257 7.83333 3.97149 7.83333H0.666667C0.298477 7.83333 0 8.13181 0 8.5C0 8.86819 0.298477 9.16667 0.666667 9.16667H3.97149C3.98257 9.16667 3.99359 9.16639 4.00453 9.16586C4.33306 11.0581 6.0381 12.5 8.0921 12.5C8.164 12.5 8.23547 12.4982 8.30647 12.4947C8.33673 12.4982 8.3675 12.5 8.39868 12.5H11.4368C11.8787 12.5 12.2368 12.1418 12.2368 11.7V11.1667H14.3333C14.7015 11.1667 15 10.8682 15 10.5C15 10.1318 14.7015 9.83333 14.3333 9.83333H12.2368Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugg);
export default __webpack_public_path__ + "static/media/plugg.0ec3b798.svg";
export { ForwardRef as ReactComponent };